import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { trackClick } from '@/lib/analytics';

interface DealerCTAProps {
  dealerTitle: string;
  dealerDesc: string;
  dealerBtnUrl: string;
  dealerBtnText: string;
}

export const DealerCTA: React.FC<DealerCTAProps> = ({
  dealerTitle,
  dealerDesc,
  dealerBtnUrl,
  dealerBtnText,
}) => {
  return (
    <section className="py-16 lg:py-24 border-t border-white/5 relative overflow-hidden">
      <div className="grid-cells-accent opacity-50" />
      <div className="container-custom text-center space-y-8 lg:space-y-10 relative z-10">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="max-w-2xl mx-auto space-y-6"
        >
          <h2
            className="font-extrabold uppercase tracking-tighter"
            dangerouslySetInnerHTML={{ __html: dealerTitle }}
          />
          <p className="text-white/50 leading-relaxed text-sm lg:text-base">
            {dealerDesc}
          </p>
          <Link to={dealerBtnUrl} className="mirror-button inline-flex mx-auto lg:rounded-none rounded-sm px-10 py-3 text-sm tracking-tight clip-path-none border border-primary/20 bg-primary/90 hover:bg-primary transition-colors" onClick={() => trackClick('become-dealer-home-section')}>
            {dealerBtnText}
          </Link>
        </motion.div>
      </div>
    </section>
  );
};
